var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWarning = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M157,352v5h1a1,1,0,0,1,0,2h-4a1,1,0,0,1,0-2h1v-5h-1a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Zm-2.414-3.586a1,1,0,0,0,.706-1.707,1,1,0,0,1,0-1.414,1.023,1.023,0,0,1,1.414,0,1,1,0,0,1,0,1.414,1,1,0,0,0,1.414,1.415,3,3,0,0,0,0-4.243,3.073,3.073,0,0,0-4.243,0,3,3,0,0,0,0,4.244A1,1,0,0,0,154.586,348.414Z",
  transform: "translate(-144 -339)"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.6a07e5a0.svg";
export { ForwardRef as ReactComponent };